<template>
  <span class="uk-label uk-width-1-1" :class="['uk-label-' + statusColor]">{{ label }}</span>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    name: {
      required: true,
      type: String
    },
    label: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      statuses: [
        {
          name: 'pending',
          label: 'Eingegangen'
        },
        {
          name: 'completed',
          label: 'Abgeschlossen'
        }
      ],
      localStatuses: []
    }
  },
  computed: {
    statusColor() {
      switch (this.name) {
        case 'pending':
          return 'primary'
        case 'completed':
          return 'success'
      }
      return 'default'
    }
  },
  mounted() {
    if (this.statuses.length) {
      this.localStatuses = _.filter(this.statuses, s => {
        return s.label !== this.label
      })
    }
  }
}
</script>
